import { render, staticRenderFns } from "./ShopMenuPublisher.vue?vue&type=template&id=1364c84a&scoped=true&"
import script from "./ShopMenuPublisher.vue?vue&type=script&lang=js&"
export * from "./ShopMenuPublisher.vue?vue&type=script&lang=js&"
import style0 from "./ShopMenuPublisher.vue?vue&type=style&index=0&id=1364c84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364c84a",
  null
  
)

export default component.exports